import { config } from './confing';
import { BlobPdf } from './models/image.model';
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import Dexie from 'dexie';

export class CedoleDb extends Dexie {
  public cedole: Dexie.Table<BlobPdf, string>;

  constructor() {
    super('CedoleDb');
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const db = this;
    //
    // Define tables and indexes
    //
    db.version(config.db).stores({
      cedole: '&cedola'
    });

    // Let's physically map BlobImage class to image table.
    db.cedole.mapToClass(CedoleDb);
  }
}

export const db: CedoleDb = new CedoleDb();

/**ImageDB
 * Delete the entire database
 */
export function deleteCedoleDatabase(): Promise<void> {
  return db.delete();
}

/**
 * Open a database
 */
export function openCedoleDatabase(): Promise<Dexie> {
  return db.open();
}

/**
 * Delete all
 */
export function deleteAllCedole(): Promise<void> {
  return db.cedole.clear();
}

/**
 * Create
 *
 */
export function createCedola(cedola: BlobPdf): Promise<string> {

    return db.cedole.put(cedola);


}


/**
 * Read images by URL
 */
export function getCedoleDB(): Promise<BlobPdf[]> {
  return db.cedole.toArray();
}

export function readCedola(cedola: string): Promise<BlobPdf[]> {
  return db.cedole
    .where('cedola')
    .equals(cedola)
    .toArray();
}

/**
 * Update cedola
 */
export function updateCedola(cedola: BlobPdf): Promise<string> {
  return db.cedole.put(cedola);
}

/**
 * Delete image
 */
export function deleteCedola(id: string): Promise<number> {
  return db.cedole
    .where('cedola')
    .equals(id)
    .delete();
}
